import React from 'react';

// The brand logo is a PNG (family-in-shield illustration) shipped in
// /app/frontend/public/brand/myfamshield-logo.png. We render it with `img`
// so it stays crisp at any size and respects color modes via a soft wrapper.
const SIZES = {
	sm: { box: 'w-8 h-8', text: 'text-base' },
	md: { box: 'w-10 h-10', text: 'text-lg' },
	lg: { box: 'w-12 h-12', text: 'text-2xl' },
	xl: { box: 'w-16 h-16', text: 'text-3xl' },
};

export default function Logo({ size = 'md', className = '', textClassName = '', mark = false }) {
	const s = SIZES[size] || SIZES.md;
	return (
		<div className={`flex items-center gap-2 ${className}`} data-testid="app-logo">
			<img
				src="/brand/myfamshield-logo.png"
				alt="MyFamShield"
				className={`${s.box} object-contain drop-shadow-sm`}
			/>
			{!mark && (
				<span className={`font-heading font-bold tracking-tight ${s.text} ${textClassName || 'text-slate-900'}`}>
					MyFam<span className="text-emerald-600">Shield</span>
				</span>
			)}
		</div>
	);
}
